import apis from '@/apis'
import Constants from '@/constants'

// URL and endpoint constants
const PATH_PREFIX = 'adapt/'
const PATH_INSTAGRAM_TAGPAGE = 'api/instagram/tagpage/'
const PATH_INSTAGRAM_USERPAGE = 'api/instagram/userpage/'

export default {
  instagramUser (token, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return apis.get(`${Constants.BASE_API}${PATH_INSTAGRAM_USERPAGE}${token}${maxidString}`)
  },

  instagramTag (tag, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return apis.get(`${Constants.BASE_API}${PATH_INSTAGRAM_TAGPAGE}${tag}/24${maxidString}`)
  },

  // info = info
  infos () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}info/all`)
  },

  infoNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}info/name/${name}`)
  },

  // hotlinks
  hotlinks () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}hotlink/all`)
  },

  hotlinkNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}hotlink/name/${name}`)
  },

  hotlinkNameLike (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}hotlink/name-like/${name}`)
  },

  // service = testimonials
  services () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}service/all`)
  },

  serviceNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}service/name/${name}`)
  },

  // about = pages
  abouts () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}about/all`)
  },

  aboutNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}about/name/${name}`)
  },

  // links
  links () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}link/all`)
  },

  linkNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}link/name/${name}`)
  },

  // links
  references () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}reference/all`)
  },

  referenceNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}reference/name/${name}`)
  },

  // faq
  faqs () {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}faq/all`)
  },

  faqNamed (name) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}faq/name/${name}`)
  },

  // survey
  surveyStatus (code) {
    return apis.get(`${Constants.BASE_API}${PATH_PREFIX}survey/status/${code}`)
  },

  surveySubmit (data) {
    return apis.post(`${Constants.BASE_API}${PATH_PREFIX}survey/submit`, data)
  },

  // carousel () {
  //   return apis.get(`${Constants.BASE_API}carousel`)
  // },
  //
  // company () {
  //   return apis.get(`${Constants.BASE_API}company`)
  // },
  //
  // gallery () {
  //   return apis.get(`${Constants.BASE_API}gallery`)
  // },
  //
  // eventDetail (showId) {
  //   return apis.get(`${Constants.BASE_API}event/show/${showId}`)
  // },
  //
  // eventPrevious () {
  //   return apis.get(`${Constants.BASE_API}event/previous`)
  // },
  //
  // eventUpcoming () {
  //   return apis.get(`${Constants.BASE_API}event/upcoming`)
  // },

  email (name, email, message, captcha, session) {
    return apis.post(`${Constants.BASE_API}email`, { name: name, email: email, phone: '-', message: message, captcha: captcha, session: session })
  },

  subscribe (name, email) {
    return apis.post(`${Constants.BASE_API}email/subscribe`, { name: name, email: email })
  },

  getRecaptcha () {
    return apis.get(`${Constants.BASE_API_BARE}captcha.php`)
  },

  youtube (path, params) {
    return apis.get(`https://www.googleapis.com/youtube/v3/${path}`, params)
  }
}



// WEBPACK FOOTER //
// ./src/apis/Site.js